import { useStore } from "vuex";
import { useCookies } from "vue3-cookies";
import {computed, ref } from "vue";
import router from "@/router";
import store from "@/store";

export default {
    name: "app",
    title: "포커패스 관리자",
    displayName: '포커패스 관리자',
    setup () {
        const { cookies } = useCookies();
        const store = useStore()
        const userInfo = computed(() => store.getters['basic/userInfo'])
        const activeIndex = ref(store.getters['basic/activeMenu'])
        const handleSelect = (key, keyPath) => {
            if(!(key === "6")){
                store.dispatch('basic/setMenuIdx', keyPath[0]).then()
            }
        }

        return {
            activeIndex,
            handleSelect,
            cookies,
            userInfo
            };
    },
    data: function () {
        return {

        }
    },
    async mounted () {
        await this.$setCodes()
    },
    methods: {
    },
    computed: {
        isAuthenticated: function (){

            if(this.userInfo.id === 0){
                return false;
            }

            return true;
        },
        currencyPath: function (){
            return router.currentRoute.value.path
        }
    }
}
